import { Store, createStore } from "redux";
import { composeWithDevTools } from 'redux-devtools-extension';
import { Action, ActionType } from './actions';
import { NotificationProps } from "./state/NotificationState";
import { RequestsData } from "./state/RequestsData";
import { combinedNotificationReducers } from './reducers';

export interface NotificationState {
    notifications: NotificationProps[]
    requestsInProgress: RequestsData
}

const notificationStore: Store<NotificationState, Action<ActionType, any>> = createStore(combinedNotificationReducers, composeWithDevTools());

export default notificationStore;
